import './ImageCard.css';

function ImageCard({ mainText, title, text, imagePath, imageAlt }) {
    return (
        <div className='image-card-container'>
            {mainText && <p className='home-main-text'>{mainText}</p>}
            <div className='image-card'>
                <img src={imagePath} alt={imageAlt} />
            </div>
            <div className='card'>
                <p className='card-text' style={{ textAlign: "start" }}>{title}</p>
                {text}
            </div>
        </div>
    );
}

export default ImageCard;
